module.exports = __webpack_public_path__ + "img/fundo_lago.dbcb13c6.jpg";